import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import { Tooltip } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		border: "1px solid #dbdbdb",
		padding: "10px",
		borderRadius: "3px",
		margin: "10px 10px 10px 0px",
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "left",
		color: theme.palette.text.secondary,
	},
	label: {
		textAlign: "right",
		fontWeight: "500",
		color: "#2c3533",
	},
	subject: {},
	from: {},
	to: {
		maxHeight: "100px",
		overflowY: "auto",
		overflowX: "hidden",
		marginBottom: "10px",
	},
	attachmentsContainer: {
		margin: "21px 10px",
	},
	attachments: {
		border: "1px solid #dbdbdb",
		borderRadius: "3px",
		padding: "12px",
		width: "80%",
	},
	attachmentsList: {
		paddingBottom: "5px",
		maxHeight: "145px",
		overflowY: "auto",
		overflowX: "hidden",
	},
	attachment: {
		display: "flex",
		color: "#2598f3",
	},
	attachmentIcon: {
		marginRight: "5px",
		paddingBottom: "5px",
	},
	fileName: {
		textDecoration: "underline",
		cursor: "pointer",
		display: "-webkit-box",
		"-webkit-line-clamp": "1",
		"-webkit-box-orient": "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis",
		WebkitLineClamp: "1",
	},
	content: {
		wordWrap: "break-word",
		wordBreak: "break-all",
		margin: "0 0 4px",
	},
	emailRef: {
		textDecoration: "underline",
		cursor: "pointer",
		display: "-webkit-box",
		"-webkit-line-clamp": "1",
		"-webkit-box-orient": "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis",
		WebkitLineClamp: "2",
	},
}))

const EmailMetadata = ({ content, item, maskHightlight, handleSelectDocument }) => {
	const classes = useStyles()

	const getContentList = (emailData) => {
		const emailDataListElements = emailData.map((data) => (
			<Tooltip title={`${data}`}>
				<p dangerouslySetInnerHTML={maskHightlight(data, item.idItem)} className={classes.content}></p>
			</Tooltip>
		))

		return <>{emailDataListElements}</>
	}

	return (
		<>
			<div className={classes.root}>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6} md={6} lg={6}>
						<Grid container spacing={3}>
							<Grid item xs={3} sm={3} md={3} lg={3}>
								<div className={classes.label}>Subject:</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} className={classes.subject}>
								{content?.documentSubject ? (
									<Tooltip title={`Subject: ${content?.documentSubject}`}>
										<p
											dangerouslySetInnerHTML={maskHightlight(content.documentSubject, item.idItem)}
											className={classes.content}
										></p>
									</Tooltip>
								) : (
									<p>-</p>
								)}
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item xs={3} sm={3} md={3} lg={3}>
								<div className={classes.label}>From:</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} className={classes.to}>
								{content?.documentFrom && Array.isArray(content.documentFrom) && !!content.documentFrom.length ? (
									getContentList(content.documentFrom)
								) : (
									<p>-</p>
								)}
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item xs={3} sm={3} md={3} lg={3}>
								<div className={classes.label}>To:</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} className={classes.to}>
								{content?.documentTo && Array.isArray(content.documentTo) && !!content.documentTo.length ? (
									getContentList(content.documentTo)
								) : (
									<p>-</p>
								)}
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item xs={3} sm={3} md={3} lg={3}>
								<div className={classes.label}>CC:</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} className={classes.to}>
								{content?.cc && Array.isArray(content.cc) && !!content.cc.length ? getContentList(content.cc) : <p>-</p>}
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item xs={3} sm={3} md={3} lg={3}>
								<div className={classes.label}>BCC:</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} className={classes.to}>
								{content?.bcc && Array.isArray(content.bcc) && !!content.bcc.length ? (
									getContentList(content.bcc)
								) : (
									<p>-</p>
								)}
							</Grid>
						</Grid>
					</Grid>

					<Grid item xs={12} sm={6} md={6} lg={6}>
						{content?.parent?.doc_id && (
							<Grid container spacing={3}>
								<Grid item xs={3} sm={3} md={3} lg={3}>
									<div className={classes.label}>Email ref.:</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} className={classes.subject}>
									<Tooltip title={content?.parent?.file_name}>
										<a onClick={() => handleSelectDocument(content.parent.doc_id)} className={classes.emailRef}>
											{content?.parent?.file_name}
										</a>
									</Tooltip>
								</Grid>
							</Grid>
						)}

						<Grid container spacing={3}>
							<Grid item xs={3} sm={3} md={3} lg={3}>
								<div className={classes.label}>Sent:</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} className={classes.subject}>
								{item.date ? (
									<p>
										{new Date(item.date).toLocaleString("en-US", {
											year: "numeric",
											month: "long",
											day: "2-digit",
											hour: "2-digit",
											minute: "2-digit",
											second: "2-digit",
										})}
									</p>
								) : (
									<p>-</p>
								)}
							</Grid>
						</Grid>
						{content?.page_number && (
							<Grid container spacing={3}>
								<Grid item xs={3} sm={3} md={3} lg={3}>
									<div className={classes.label}>Page:</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} className={classes.subject}>
									{content?.total_page_number === 1 ? (
										<p>{content.page_number}</p>
									) : (
										<p>
											{" "}
											{content.page_number} of {content.total_page_number}
										</p>
									)}
								</Grid>
							</Grid>
						)}
						<Grid container spacing={3} className={classes.attachmentsContainer}>
							<div className={classes.attachments}>
								<div style={{ paddingBottom: "10px", textAlign: "left" }} className={classes.label}>
									Attachments: {content?.children.length === 0 ? "-" : ""}
								</div>
								{content?.children.length > 0 && (
									<div className={classes.attachmentsList}>
										{content?.children.map((attachment) => (
											<div className={classes.attachment} onClick={() => handleSelectDocument(attachment?.doc_id)}>
												<i className={`bi bi-file-earmark ${classes.attachmentIcon}`}></i>

												<Tooltip title={attachment.file_name}>
													<div className={classes.fileName}>{attachment.file_name}</div>
												</Tooltip>
											</div>
										))}
									</div>
								)}
							</div>
						</Grid>
					</Grid>
				</Grid>
			</div>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "10px" }}>
					<strong>Content: </strong>
				</Grid>
			</Grid>
		</>
	)
}

export default EmailMetadata
